import React from 'react';
import { motion } from 'framer-motion';
import ResearchCardSkeleton from './ResearchCardSkeleton';

interface ResearchLoadingStatesProps {
  isLoading: boolean;
  error: Error | null;
  hasData: boolean;
}

export const ResearchLoadingStates: React.FC<ResearchLoadingStatesProps> = ({
  isLoading,
  error,
  hasData,
}) => {
  // Initial loading state with skeletons
  if (isLoading && !hasData && !error) {
    return (
      <div className="space-y-4 py-4">
        <motion.div 
          className="grid grid-cols-1 2xl:grid-cols-2 gap-2 md:gap-6"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
          style={{ 
            transform: 'translateZ(0)',
            backfaceVisibility: 'hidden',
            willChange: 'transform'
          }}
        >
          {Array.from({ length: 6 }).map((_, index) => (
            <ResearchCardSkeleton key={`loading-skeleton-${index}`} index={index} />
          ))}
        </motion.div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="text-center py-12">
        <p className="text-red-500">Failed to load research: {error.message}</p>
      </div>
    );
  }

  return null;
};

export default ResearchLoadingStates;
